import { Cross } from '@/components/icons';
import UpgradeAccountButton from '@/components/subscription/UpgradeAccountButton';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type SubscriptionCtaBannerProps = {
    title: string;
    description: string;
    onClose: () => void;
    className?: string;
};

export default function SubscriptionCtaBanner({
    title,
    description,
    onClose,
    className,
}: SubscriptionCtaBannerProps) {
    return (
        <div className={cn('relative overflow-visible', className)}>
            <Button
                type="button"
                variant="ghost"
                size="icon"
                className="absolute -right-3 -top-3 z-10 size-9 rounded-full border border-border/70 bg-card text-muted-foreground shadow-md hover:bg-card hover:text-foreground"
                onClick={onClose}
                aria-label="Fechar aviso de assinatura"
            >
                <Cross className="size-4" />
            </Button>
            <div className="relative overflow-hidden rounded-2xl border border-brand/15 bg-card/95 p-5 shadow-elevation-1">
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute -right-10 top-0 size-24 rounded-full bg-brand/10 blur-3xl"
                />
                <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                    <div className="flex items-start gap-4">
                        <div className="space-y-1.5">
                            <p className="text-lg font-semibold text-foreground">{title}</p>
                            <p className="max-w-2xl text-sm leading-relaxed text-muted-foreground">
                                {description}
                            </p>
                        </div>
                    </div>

                    <UpgradeAccountButton className="h-11 w-full md:w-auto" />
                </div>
            </div>
        </div>
    );
}
